import {
  TableCell,
  tableCellClasses,
  TableRow,
  Theme,
  Typography,
} from '@mui/material'
import styled from 'styled-components'

export const StyledTableCell = styled(TableCell)<{ theme: Theme }>(
  ({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.common.black,
      fontSize: 15,
      fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 15,
      fontWeight: 700,
    },
    [`&.${tableCellClasses.head} p`]: {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.common.black,
      fontSize: 15,
      fontWeight: 300,
    },
  })
)

export const StyledTableRow = styled(TableRow)<{ theme: Theme }>(
  ({ theme }) => ({
    minHeight: 100,
    '&:nth-of-type(odd)': {
      //   backgroundColor: theme.palette.action.hover,
      backgroundColor: theme.palette.common.white,
    },
    '&:nth-of-type(even)': {
      //   backgroundColor: theme.palette.action.hover,
      backgroundColor: theme.palette.secondary.light,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  })
)

export const DocumentTypeNonDropdown = styled(Typography)<{
  theme: Theme
  isupload: string
  condensed?: string
}>(({ theme, isupload, condensed }) => ({
  backgroundColor:
    isupload === 'true'
      ? theme.palette.primary.main
      : theme.palette.secondary.dark,
  color: theme.palette.common.white,
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: 8,
  paddingRight: 8,
  fontWeight: '700 !important',
  borderRadius: '5px',
  fontSize: '15px !important',
  height: condensed === 'true' ? 35 : 45,
  display: 'flex',
  alignItems: 'center',
  width: '85%',
}))
